import React, { useState } from 'react';
import AdminButton from '../../../components/admin/AdminButton';
import './QuestionEditor.css'; // Shared styles

const ComponentEditor = ({ component, onSave, onCancel }) => {
    const [formData, setFormData] = useState({ ...component });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        if (!formData.name || !formData.code) {
            alert('명칭과 코드를 모두 입력해주세요.');
            return;
        }
        onSave(formData);
    };

    return (
        <div className="editor-overlay">
            <div className="admin-form" style={{ width: '500px' }}>
                <h2 className="admin-title" style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>
                    {component.id ? '가격 요소 수정' : '새 가격 요소 추가'}
                </h2>

                <div className="form-group">
                    <label>명칭 (예: 기본료)</label>
                    <input
                        className="form-control"
                        name="name"
                        value={formData.name || ''}
                        onChange={handleChange}
                        placeholder="요소 명칭 입력"
                    />
                </div>

                <div className="form-group">
                    <label>코드 (예: BASE_FEE)</label>
                    <input
                        className="form-control"
                        name="code"
                        value={formData.code || ''}
                        onChange={handleChange}
                        placeholder="고유 코드 입력"
                    />
                </div>

                <div className="form-group">
                    <label>기본 단가 (Default Price)</label>
                    <input
                        type="number"
                        className="form-control"
                        name="defaultPrice"
                        value={formData.defaultPrice || 0}
                        onChange={handleChange}
                        placeholder="0"
                    />
                </div>

                <div className="form-group">
                    <label>관리자 메모 (설명)</label>
                    <textarea
                        className="form-control"
                        name="adminMemo"
                        value={formData.adminMemo || ''}
                        onChange={handleChange}
                        placeholder="이 요소에 대한 설명이나 비고를 입력하세요."
                        style={{ minHeight: '80px', resize: 'vertical' }}
                    />
                </div>



                <div className="form-buttons" style={{ marginTop: '30px' }}>
                    <AdminButton onClick={handleSave} variant="primary">저장</AdminButton>
                    <AdminButton onClick={onCancel} variant="secondary">닫기</AdminButton>
                </div>
            </div>
        </div>
    );
};

export default ComponentEditor;
